import { useCallback, useEffect, useState } from 'react';
import { API_BASE } from '../config';
import type { TierDefaults } from '../types/tier-limits';

interface UseTierDefaultsResult {
  tierDefaults: TierDefaults | null;
  loading: boolean;
}

export function useTierDefaults(): UseTierDefaultsResult {
  const [tierDefaults, setTierDefaults] = useState<TierDefaults | null>(null);
  const [loading, setLoading] = useState(true);

  const fetchTierDefaults = useCallback(async (): Promise<void> => {
    try {
      setLoading(true);
      const response = await fetch(`${API_BASE}/api/tier-defaults`);

      if (response.ok) {
        const data = await response.json();
        setTierDefaults(data);
      }
    } catch (error) {
      console.error('Error fetching tier defaults:', error);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchTierDefaults();
  }, [fetchTierDefaults]);

  return { tierDefaults, loading };
}
